/**
 * <cba-recommendations> — "You may also like" from Shopify's own product
 * recommendations (DESIGN-PLAN 7.G3, site audit B8), as Dawn's
 * product-recommendations and Horizon's product-recommendations.js load
 * them. On the product page (sections/cba-ymal) and in the cart drawer
 * (sections/cba-cart-drawer; DESIGN-PLAN 7.A, site audit B11.8).
 *
 *   <cba-recommendations [hidden] [data-limit="6"]
 *     data-url="/recommendations/products?limit=10&product_id=…&section_id=…&intent=related">
 *     … <ul data-scroller-track> the collection's cards </ul> …
 *   </cba-recommendations>
 *
 * The page renders a collection, so the row is there without JavaScript. One
 * request asks Shopify for the product's related products, rendered by the
 * section in the address; when Shopify has some (data-recommended > 0 in the
 * answer, and cards in its row), its cards take the row's place, data-limit
 * of them at most. With none, or when the request fails, the collection
 * stays. Where the page rendered no row, the answer's whole row is taken.
 *
 * - On a page the request is made when the row comes near the screen. The
 *   row keeps its size, so nothing below moves.
 * - A row that starts [hidden] (the cart drawer's) is asked for when the
 *   panel around it ([data-recommendations-view]) shows, and is shown when
 *   the answer is in, whatever it was: its cards do not change under the
 *   visitor's eyes.
 */
if (!customElements.get('cba-recommendations')) {
  class CbaRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-performed') || !this.dataset.url) { this.hidden = false; return; }
      const watched = (this.hidden && this.closest('[data-recommendations-view]')) || this;
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 400px 0px' });
      this.observer.observe(watched);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    load() {
      fetch(this.dataset.url)
        .then((r) => { if (!r.ok) throw new Error('recommendations ' + r.status); return r.text(); })
        .then((html) => {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cba-recommendations');
          if (!fresh || !(Number(fresh.dataset.recommended) > 0)) return;
          const freshTrack = fresh.querySelector('[data-scroller-track]');
          if (!freshTrack || !freshTrack.children.length) return;
          const limit = Number(this.dataset.limit);
          if (limit > 0) [...freshTrack.children].slice(limit).forEach((card) => card.remove());
          const track = this.querySelector('[data-scroller-track]');
          if (track) {
            track.replaceChildren(...freshTrack.children);
            track.scrollLeft = 0;
            /* The new cards start themselves (<cba-product-card>); the arrows
               follow the new row. */
            track.dispatchEvent(new Event('scroll'));
          } else {
            this.replaceChildren(...fresh.children);
          }
          this.setAttribute('data-performed', '');
        })
        .catch(() => { /* the collection stays */ })
        .finally(() => { this.hidden = false; });
    }
  }

  customElements.define('cba-recommendations', CbaRecommendations);
}
